import { IUpdateContratoServicoUseCase } from "../../../presentation/useCases/update/update_contrato_servico_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateContratoServicoUseCase


export class UpdateContratoServicoUseCase implements IUpdateContratoServicoUseCase
 {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateContratoServico(
  IdContratoServico: number, IdContrato: number, IdProdutoServico: number, Detalhamento: string | null, Quantidade: number | null, ValorUnitario: number | null, ValorTotal: number | null
  ): Promise<void> {
    
    await this.repository.updateContratoServico(
     IdContratoServico, IdContrato, IdProdutoServico, Detalhamento, Quantidade, ValorUnitario, ValorTotal
    );
  }
}
